// HomePage.js
import React from 'react';
import Hero from '../components/Hero';
import Pathways from '../components/Pathways';
import HowWeWork from '../components/HowWeWork';
import FeaturedChecks from '../components/FeaturedChecks';
import TravelServices from '../components/TravelServices';
import Services from '../components/Services';
import MediaSection from '../components/MediaSection';
import HowItWorksComponent from '../components/HowItWorksComponent';
import AboutUs from '../components/AboutComponent';
import ScamTypes from '../components/ScamTypes';
import Reviews from '../components/Reviews';
import FAQs from '../components/FAQs';


const HomePage = () => {
  return (
    <div>
      <Hero />
      <Services />
      <Pathways />
      <HowWeWork />
      <FeaturedChecks />
      <TravelServices />
      <FAQs />
      {/* <MediaSection /> */}
      {/* <HowItWorksComponent />
      <AboutUs />
      <ScamTypes /> */}
      {/* <Reviews /> */}

      {/* More sections can be added here later */}
    </div>
  );
};

export default HomePage;
